import { hexToRGB } from '../../color';
import { OTHER_IMAGERY_TYPES } from '../../../constants/mapLayerIds';

// NDVI is an acronym for Normalized difference vegetation index
// https://en.wikipedia.org/wiki/Normalized_difference_vegetation_index
function parseNDVILegend(legend) {
  if (!legend || !legend.length) {
    return [];
  }

  return legend
    .sort((a, b) => b.low - a.low)
    .map(({ color, low, high }) => ({
      ...hexToRGB(color),
      stringValue: `${low} - ${high}`,
    }));
}

/**
 * Parse the legend for the thermal images.
 * Returns an array of legend that includes the color of each one.
 * @param {Array} legend - Legend Array
 * @return {Array} - Parse Legend Array
 */
export function parseThermalLegend(legend) {
  if (!Array.isArray(legend)) {
    return [];
  }

  return legend.map(({ color }) => ({ ...hexToRGB(color), stringValue: '' }));
}

function parseLegend(layer, legend) {
  switch (layer) {
    case OTHER_IMAGERY_TYPES.NDVI:
      return parseNDVILegend(legend);
    case OTHER_IMAGERY_TYPES.THERMAL:
      return parseThermalLegend(legend);
    default:
      return [];
  }
}

function extractEvent(event) {
  const { eventDate, layer, meta } = event;
  const [payload] = event.payload;

  return {
    date: eventDate,
    imageUri: payload.uri,
    northeastPoint: payload.meta.bbox.northeast.coordinates.reverse(),
    southwestPoint: payload.meta.bbox.southwest.coordinates.reverse(),
    legend: parseLegend(layer, meta.legend),
    name: meta.name,
  };
}

export function extractOtherImagery(events) {
  if (!events.length) {
    return {};
  }

  const result = events.reduce((groupedByVendor, event) => {
    const { layer } = event;
    const { vendor } = event.meta;
    const newGroupedByVendor = { ...groupedByVendor };

    let vendorLayers = newGroupedByVendor[vendor];
    if (!vendorLayers) {
      newGroupedByVendor[vendor] = {};
      vendorLayers = newGroupedByVendor[vendor];
    }

    const extractedEvent = extractEvent(event);
    vendorLayers[layer] = vendorLayers[layer]
      ? [...vendorLayers[layer], extractedEvent]
      : [extractedEvent];
    return newGroupedByVendor;
  }, {});

  const [vendor] = Object.keys(result);
  const [layer] = Object.keys(result[vendor]);

  const defaultActiveLayer = {
    vendor,
    layer,
    index: 0,
  };

  result.activeSubLayerIds = [defaultActiveLayer, defaultActiveLayer];

  return result;
}
